// Utilities for simulating network tests in a browser environment
export const measureLatency = async (url) => {
  const start = performance.now();
  try {
    // mode: 'no-cors' allows us to measure RTT even if the resource doesn't allow CORS.
    await fetch(url, {
      method: 'HEAD',
      mode: 'no-cors',
      cache: 'no-store',
      signal: AbortSignal.timeout(3000)
    });
    const end = performance.now();
    return Math.round(end - start);
  } catch (error) {
    return -1;
  }
};

export const getStabilityScore = (latency, jitter, packetLoss) => {
  let score = 100;
  
  // 5G Optimized Scoring: High penalties for latency > 50ms
  if (latency > 50) score -= 15;
  if (latency > 100) score -= 25;
  if (latency > 300) score -= 40;

  // Penalize jitter (5G should be very stable)
  if (jitter > 10) score -= 15;
  if (jitter > 30) score -= 30;

  // Penalize packet loss (heavy penalty)
  if (packetLoss > 0) score -= (packetLoss * 10);

  return Math.max(0, Math.round(score));
};

export const getConnectionType = () => {
  if (navigator.connection) {
    const { effectiveType, type, downlink } = navigator.connection;
    
    // Logic to identify 5G based on effective type and high downlink capacity
    const isHighSpeedCellular = (type === 'cellular' || !type) && (effectiveType === '4g' || downlink > 10);
    
    return {
      type: isHighSpeedCellular ? '5G Mobile Data' : (type === 'wifi' ? 'Wi-Fi 6' : 'Ethernet/Broadband'),
      effective: isHighSpeedCellular ? '5G UW' : (effectiveType ? effectiveType.toUpperCase() : 'HIGH-SPEED'),
      is5G: isHighSpeedCellular,
      downlink: downlink || '---'
    };
  }
  // Default to 5G for this update as requested
  return { type: '5G Mobile Data', effective: '5G UW', is5G: true, downlink: '---' };
};